export default __webpack_public_path__ + "static/media/Ganster_BGM.113657e5.mp3";